<template>
<span>
  <span v-if="value && integerPart === 0 && value.value < 0">-</span>
  <span :class="{lighter : isLessThanOne}">{{integerPart | number('0,0')}}.</span>
  <span :class="[unisize ? '' : 'smaller', isLessThanOne && fractionalPart !== '00' ? 'darker' : 'lighter']">{{fractionalPart}}</span>
  <span v-if="value" class="smaller"> {{value.currency}}</span>
</span>
</template>

<script>
export default {
  name: 'DisplayAmountObj',
  props: {
    value: [Object],
    unisize: { type: Boolean, default: false },
    scale: { type: Number, default: 2 }
  },
  computed: {
    integerPart: function () {
      if (!this.value || !this.value.value || isNaN(this.value.value)) {
        return 0;
      }
      return Math.trunc(this.value.value)
    },
    fractionalPart: function () {
      if (!this.value || !this.value.value || isNaN(this.value.value)) {
        return ''.padStart(this.scale, '0');
      }
      const x = Math.abs( Math.round( (this.value.value - this.integerPart) * 100 ) )
      return (String(x).padStart(this.scale, '0'))
    },
    isLessThanOne: function () {
      if (!this.value || !this.value.value || isNaN(this.value.value)) {
        return true
      }
      if (this.value.value < 1 && this.value.value > 0) {
        return true
      }
      return false
    }
  }
}
</script>

<style scoped>
.lighter { font-weight: lighter;}
.smaller { font-size: 75%; }
.darker { font-weight: 500; }
</style>
